var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _g, _path16, _g2, _path17, _path18, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 50,
    viewBox: "0 0 206 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.8872 51.6281C82.0858 51.619 82.2836 51.6581 82.4639 51.7419C82.6441 51.8258 82.8014 51.9519 82.9223 52.1097C83.1657 52.52 83.2937 52.9885 83.2929 53.4656C83.292 53.9427 83.1623 54.4107 82.9174 54.8202C82.7892 54.9723 82.6293 55.0946 82.4489 55.1785C82.2684 55.2625 82.0719 55.306 81.8729 55.3062C81.674 55.3063 81.4774 55.2631 81.2968 55.1794C81.1163 55.0958 80.9562 54.9737 80.8277 54.8218H80.7765L80.6387 55.2424H80.0717V50.2478H80.8258V51.4349C80.8258 51.5229 80.8221 51.6534 80.813 51.8266C80.8039 51.9998 80.7981 52.1101 80.7942 52.1569H80.8258C80.9417 51.9843 81.1005 51.8449 81.2866 51.7521C81.4727 51.6594 81.6796 51.6167 81.8872 51.6281ZM81.6915 52.2444C81.5686 52.2329 81.4447 52.2512 81.3305 52.2979C81.2162 52.3446 81.1149 52.4183 81.0353 52.5126C80.8772 52.7838 80.8048 53.0965 80.8277 53.4097V53.4609C80.802 53.7872 80.8736 54.1139 81.0335 54.3996C81.1121 54.5002 81.2147 54.5795 81.3319 54.6303C81.4491 54.681 81.5771 54.7016 81.7043 54.6901C81.8247 54.6959 81.9445 54.6695 82.0513 54.6136C82.1582 54.5578 82.2483 54.4745 82.3123 54.3724C82.467 54.0924 82.5387 53.7741 82.5192 53.4548C82.5187 52.6476 82.2426 52.2441 81.6908 52.2444H81.6915Z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6292 51.6926H84.4509L85.1724 53.705C85.2744 53.9658 85.3475 54.237 85.3903 54.5137H85.4159C85.442 54.3688 85.4772 54.2257 85.5216 54.0854C85.5733 53.9176 85.8448 53.12 86.3363 51.6926H87.1509L85.6324 55.714C85.3566 56.4522 84.8966 56.8214 84.2523 56.8215C84.0882 56.8217 83.9247 56.8034 83.7647 56.767V56.1696C83.8922 56.197 84.0225 56.21 84.1529 56.2084C84.5165 56.2084 84.7726 55.9976 84.9211 55.576L85.0528 55.2424L83.6292 51.6926Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8929 56.0648H89.1472V49.357H90.8929V56.0648Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6797 56.0643H97.9445V51.0473L95.8426 54.9187L93.7401 51.0473V56.0643H92.0048V49.3565H94.1516L95.9094 52.6604L97.7443 49.3565H99.6797V56.0643Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.355 56.0643H102.461C102.19 56.0697 101.92 56.036 101.66 55.9642C101.452 55.9068 101.265 55.7911 101.12 55.6307C100.971 55.4516 100.867 55.2401 100.814 55.0132C100.741 54.6978 100.707 54.3746 100.714 54.0509V53.3613C100.708 53.0416 100.74 52.7224 100.809 52.4102C100.858 52.1832 100.961 51.9714 101.109 51.7927C101.254 51.6323 101.441 51.5165 101.649 51.4591C101.913 51.3868 102.187 51.353 102.461 51.3588H105.598V51.0473C105.598 50.5953 105.394 50.3691 104.986 50.3688H100.925V49.3565H105.62C105.892 49.3504 106.164 49.3841 106.426 49.4566C106.632 49.5156 106.817 49.6313 106.96 49.7904C107.109 49.9691 107.212 50.1808 107.261 50.4077C107.329 50.72 107.361 51.0391 107.355 51.3588V56.0643ZM105.598 55.052V52.3713H103.05C102.657 52.3713 102.461 52.5604 102.461 52.9385V54.5516C102.461 54.8854 102.654 55.0522 103.039 55.052H105.598Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.063 55.9971C115.069 56.313 115.038 56.6285 114.969 56.937C114.92 57.1652 114.815 57.3775 114.663 57.5545C114.517 57.7138 114.33 57.8309 114.123 57.8936C113.862 57.9699 113.59 58.0055 113.317 57.9993H109.046V56.9751H112.761C112.835 56.9858 112.91 56.979 112.981 56.9554C113.052 56.9317 113.117 56.8919 113.169 56.839C113.222 56.7862 113.262 56.7217 113.286 56.6507C113.31 56.5798 113.316 56.5043 113.306 56.4302V56.0629H110.159C109.52 56.0629 109.071 55.9258 108.813 55.6514C108.554 55.3771 108.424 54.9321 108.423 54.3165V51.1253C108.419 50.8597 108.447 50.5945 108.507 50.3355C108.552 50.1318 108.648 49.9426 108.785 49.7848C108.927 49.6323 109.107 49.5208 109.308 49.4622C109.577 49.3851 109.856 49.3495 110.136 49.3565H115.063V55.9971ZM113.306 50.3681H110.715C110.64 50.3567 110.564 50.3627 110.492 50.3859C110.42 50.4091 110.354 50.4487 110.3 50.5016C110.246 50.5545 110.206 50.6192 110.181 50.6907C110.156 50.7621 110.149 50.8383 110.159 50.9133V54.4953C110.148 54.5708 110.155 54.6479 110.179 54.7203C110.203 54.7927 110.244 54.8585 110.298 54.9125C110.352 54.9665 110.417 55.0071 110.49 55.0312C110.562 55.0553 110.639 55.0622 110.715 55.0513H113.306V50.3681Z",
    fill: "#231F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.131 51.1809C116.126 50.8944 116.158 50.6084 116.226 50.3299C116.277 50.1188 116.381 49.9237 116.526 49.7625C116.673 49.6123 116.857 49.5047 117.06 49.451C117.323 49.3826 117.595 49.3508 117.867 49.3565H121.026C121.298 49.3508 121.569 49.3826 121.832 49.451C122.036 49.506 122.222 49.6134 122.372 49.7625C122.521 49.9224 122.626 50.1178 122.678 50.3299C122.746 50.6084 122.778 50.8944 122.773 51.1809V54.228C122.778 54.5146 122.746 54.8006 122.678 55.079C122.626 55.2912 122.521 55.4865 122.372 55.6463C122.222 55.7961 122.036 55.9052 121.832 55.9633C121.57 56.0358 121.298 56.0695 121.026 56.0634H117.867C117.595 56.0695 117.323 56.0358 117.06 55.9633C116.857 55.9065 116.673 55.7972 116.526 55.6463C116.381 55.4851 116.277 55.2902 116.226 55.079C116.158 54.8006 116.126 54.5146 116.131 54.228V51.1809ZM121.026 50.9139C121.037 50.8399 121.03 50.7644 121.006 50.6934C120.983 50.6224 120.943 50.5579 120.89 50.505C120.837 50.4521 120.773 50.4122 120.702 50.3886C120.631 50.3649 120.555 50.3582 120.481 50.3688H118.423C118.348 50.3574 118.272 50.3636 118.2 50.3868C118.128 50.41 118.063 50.4496 118.009 50.5025C117.955 50.5554 117.914 50.6201 117.889 50.6915C117.865 50.7629 117.857 50.839 117.867 50.9139V54.496C117.856 54.5715 117.863 54.6485 117.887 54.7209C117.911 54.7932 117.952 54.859 118.006 54.913C118.06 54.9669 118.126 55.0076 118.198 55.0317C118.27 55.0558 118.347 55.0628 118.423 55.052H120.481C120.556 55.062 120.632 55.0544 120.704 55.0298C120.775 55.0052 120.84 54.9643 120.893 54.9104C120.946 54.8564 120.985 54.7909 121.008 54.7189C121.032 54.647 121.038 54.5707 121.026 54.496V50.9139Z",
    fill: "#231F20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4113 38.4578C85.2012 39.6458 85.6676 40.2396 86.8107 40.2392H96.9941L96.4206 43.4811H84.5226C83.7009 43.5035 82.8809 43.3953 82.0932 43.1603C81.51 42.9843 80.9969 42.6292 80.6268 42.1452C80.2597 41.6084 80.0501 40.9795 80.0216 40.3297C79.9704 39.4169 80.0346 38.5012 80.2127 37.6045L81.9401 27.8435C82.0905 26.908 82.3501 25.9934 82.7136 25.1183C82.9973 24.4323 83.4223 23.8136 83.961 23.3028C84.4811 22.8312 85.1055 22.4894 85.783 22.3054C86.6117 22.0889 87.4661 21.9871 88.3225 22.0028H100.221L99.6472 25.2419H89.4637C88.3202 25.2419 87.6458 25.8238 87.4403 26.9877L85.4113 38.4578Z",
    fill: "#231F20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M101.657 27.8424C101.807 26.9069 102.067 25.9923 102.43 25.1172C102.714 24.4311 103.139 23.8125 103.678 23.3016C104.198 22.8301 104.822 22.4883 105.5 22.3042C106.328 22.0878 107.183 21.986 108.039 22.0016H117.777C118.598 21.9804 119.418 22.0824 120.21 22.3042C120.798 22.4721 121.318 22.8211 121.696 23.3016C122.073 23.8347 122.289 24.4649 122.318 25.1172C122.369 26.03 122.304 26.9456 122.127 27.8424L120.399 37.6033C120.248 38.5388 119.989 39.4534 119.626 40.3286C119.34 41.0176 118.908 41.6369 118.361 42.1441C117.83 42.6152 117.201 42.962 116.519 43.1592C115.691 43.3882 114.834 43.4962 113.976 43.4799H104.238C103.417 43.5024 102.597 43.3941 101.809 43.1592C101.226 42.9831 100.713 42.628 100.342 42.1441C99.9753 41.6072 99.7656 40.9783 99.7372 40.3286C99.6858 39.4157 99.75 38.5001 99.9283 37.6033L101.657 27.8424ZM116.895 26.9872C117.1 25.8243 116.643 25.2424 115.524 25.2415H109.18C108.037 25.2415 107.362 25.8234 107.157 26.9872L105.127 38.4578C104.917 39.6459 105.383 40.2396 106.526 40.2392H112.87C113.99 40.2392 114.655 39.6454 114.865 38.4578L116.895 26.9872Z",
    fill: "#231F20"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M175.251 43.4811H160.164C159.348 43.5012 158.534 43.393 157.752 43.1603C157.153 42.9829 156.633 42.6058 156.278 42.0917C155.913 41.4951 155.708 40.8138 155.685 40.1144C155.64 39.0815 155.719 38.0469 155.922 37.0331L156.313 34.8246C156.48 33.7825 156.758 32.7614 157.143 31.7786C157.43 31.0398 157.864 30.367 158.419 29.8013C158.938 29.2978 159.575 28.9306 160.271 28.7327C161.105 28.5045 161.967 28.3965 162.831 28.4119H172.5L172.677 27.4146C172.933 25.9668 172.433 25.2425 171.176 25.2419H158.66L159.233 22H173.703C174.525 21.9776 175.345 22.0858 176.132 22.3207C176.725 22.502 177.238 22.8787 177.589 23.3894C177.953 23.9857 178.152 24.6682 178.165 25.3667C178.199 26.3879 178.116 27.4096 177.918 28.4119L175.251 43.4811ZM170.407 40.2389L171.927 31.6537H164.075C162.863 31.6537 162.15 32.2588 161.936 33.4692L161.022 38.6347C160.833 39.7034 161.332 40.2378 162.521 40.2378L170.407 40.2389Z",
    fill: "#231F20"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M130.173 39.9024C128.899 39.9024 128.051 38.8982 128.191 37.6185L129.066 33.1175L131.227 22.0089H126.177L123.008 38.3023C122.452 41.1621 124.257 43.4802 127.039 43.4802H135.931L136.627 39.9014H130.174L130.173 39.9024Z",
    fill: "#231F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M146.843 39.9024C145.569 39.9024 144.721 38.8982 144.861 37.6185L145.736 33.1175L147.897 22.0089H142.848L139.679 38.3023C139.123 41.1621 140.928 43.4802 143.71 43.4802H152.602L153.298 39.9014H146.845L146.843 39.9024Z",
    fill: "#231F20"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M200.179 34.2001C200.131 33.3917 199.98 32.8943 199.65 32.4018C199.306 31.9058 198.806 31.5395 198.23 31.3616C198.303 31.2184 198.374 31.0734 198.441 30.9179C198.816 29.9871 199.084 29.0172 199.242 28.0263C199.429 27.0856 199.507 26.1266 199.475 25.1682C199.463 24.5126 199.277 23.872 198.935 23.3126C198.602 22.8304 198.114 22.4766 197.552 22.3098C196.807 22.0902 196.032 21.9887 195.256 22.0089H182.422L181.26 28.5728H181.263C181.255 28.6156 181.246 28.6543 181.238 28.6976L178.606 43.57H193.496C194.338 43.5839 195.177 43.4773 195.989 43.2535C196.676 43.0586 197.304 42.6962 197.817 42.1988C198.367 41.6388 198.8 40.9756 199.093 40.2473C199.487 39.2685 199.77 38.2484 199.936 37.2063C200.132 36.2168 200.213 35.2082 200.179 34.2001ZM187.02 25.0511H193.766C194.371 25.0511 194.822 25.6795 194.723 26.382L194.213 30.0192C194.193 30.2808 194.08 30.5267 193.895 30.7122C193.71 30.8978 193.464 31.0107 193.202 31.0306H186.077L187.02 25.0511ZM194.859 35.87L194.342 38.7886C194.156 39.8438 193.476 40.3714 192.302 40.3714H184.519L185.633 34.0777H193.381C194.578 34.0772 195.07 34.6746 194.859 35.87Z",
    fill: "#231F20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6224 7.19943L50.1649 20.6562L66.4904 25.7651C66.802 25.8625 67.1343 25.873 67.4513 25.795C67.7683 25.7171 68.058 25.5538 68.2889 25.323C68.5197 25.0921 68.683 24.8024 68.7609 24.4854C68.8389 24.1684 68.8284 23.8361 68.731 23.5245L63.6224 7.19943Z",
    fill: "url(#paint0_linear_6930_829)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1649 20.6562L63.6224 7.19861L65.1806 12.1877L55.1613 22.2196L50.1649 20.6562Z",
    fill: "url(#paint1_linear_6930_829)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7243 60.9543L58.346 67.984L47.6418 53.7036L57.0201 46.6739C57.2749 46.483 57.5648 46.344 57.8733 46.2651C58.1817 46.1861 58.5027 46.1686 58.8179 46.2138C59.1331 46.2588 59.4364 46.3656 59.7103 46.528C59.9843 46.6903 60.2235 46.905 60.4144 47.1598L68.2101 57.56C68.401 57.8148 68.5401 58.1046 68.619 58.4131C68.6979 58.7216 68.7153 59.0426 68.6702 59.3578C68.625 59.673 68.5183 59.9763 68.356 60.2502C68.1937 60.524 67.9791 60.7634 67.7243 60.9543Z",
    fill: "url(#paint2_linear_6930_829)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6930_829",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 0,
    width: 58,
    height: 41
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2758 0.867188L62.7455 5.57016L48.4918 20.0768C48.4918 20.0768 35.5902 16.5509 24.2262 20.3753C12.8621 24.1998 8.90311 34.5036 8.90311 34.5036L5.69147 40.8945C5.69147 40.8945 6.38038 29.2899 6.88493 27.2717C8.23038 24.5808 9.16367 22.3926 10.1266 20.3753C11.0895 18.3581 11.8791 18.7706 13.6122 14.8263C17.3122 11.4626 13.6122 14.8263 17.6486 10.9581C17.6486 10.9581 17.6486 10.9581 24.2262 5.57016C24.3359 5.39085 29.2531 4.06264 32.9531 2.38082C34.0288 2.44059 39.6804 0.867188 39.6804 0.867188H50.2758Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6930_829)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2687 18.0292C36.6062 16.4654 44.6355 17.4532 51.0716 20.787C54.2159 22.4124 56.9836 24.6141 59.08 27.3512L72.4755 14.2023C68.9213 10.2022 64.5373 6.99896 59.619 4.80873C54.7008 2.61848 49.3627 1.49215 43.9648 1.50567C23.0637 1.50567 6.12457 18.1324 6.12457 38.6487C7.81029 33.5171 10.8354 28.9114 14.8973 25.2929C18.959 21.6742 23.915 19.1696 29.269 18.0295L29.2687 18.0292Z",
    fill: "url(#paint3_linear_6930_829)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5164 8.5633C41.1875 8.0113 46.9095 8.83481 52.1828 10.962C57.456 13.0891 62.1202 16.4551 65.7678 20.7661L72.4758 14.2019C68.1141 9.31446 62.5314 5.63349 56.2807 3.52352C50.0299 1.41355 43.3277 0.947759 36.8378 2.17229C30.348 3.39681 24.2955 6.26916 19.2799 10.5049C14.2641 14.7407 10.4591 20.1929 8.24152 26.3218C10.9702 21.3947 14.8826 17.2001 19.6369 14.1045C24.3912 11.0089 29.8429 9.10632 35.516 8.56298L35.5164 8.5633Z",
    fill: "url(#paint4_linear_6930_829)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6930_829",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 19,
    width: 53,
    height: 55
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7849 20.2622L18.852 23.6868L13.444 27.9445L9.07131 33.8308L5.20312 42.2399C5.20312 42.2399 8.86106 50.649 7.89403 52.3308C9.92532 54.0097 14.2805 63.277 20.3395 66.7945C26.3984 70.3119 28.919 71.6511 35.1905 72.8011C41.462 73.9511 49.2668 72.8011 49.2668 72.8011L57.1713 69.3172L45.8927 53.7234L32.7268 50.5178C32.7268 50.5178 30.4924 31.4041 30.6107 29.7945C30.6107 26.9724 33.4075 25.3495 34.3027 24.5802C35.1979 23.8109 36.6903 22.7906 37.3736 22.3275C38.0569 21.8645 38.2535 20.0978 38.2535 20.0978C38.2535 20.0978 37.3271 19.909 35.6233 19.6652C33.9195 19.4214 31.9015 19.0203 31.2812 19.0429C30.6609 19.0655 25.7849 20.2622 25.7849 20.2622Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6930_829)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4714 54.8362C42.4553 55.2643 40.3797 55.3334 38.3397 55.0403C36.0848 54.7211 33.9149 53.9605 31.9541 52.8022C29.9934 51.6438 28.2801 50.1103 26.9123 48.2893C25.5447 46.4684 24.5493 44.3957 23.983 42.1899C23.417 39.9839 23.291 37.6882 23.6128 35.4335C18.1156 50.5616 30.9159 71.8435 49.0085 71.4579C54.3145 70.1651 59.2419 67.6416 63.3917 64.0914L52.9928 50.2616C50.6379 52.5557 47.6851 54.141 44.4719 54.8362H44.4714Z",
    fill: "url(#paint5_linear_6930_829)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.009 71.4587C32.1021 70.7382 21.1833 52.4105 23.6133 35.4343C24.0993 32.0394 25.5831 28.8655 27.8764 26.3154C30.1697 23.7654 33.1689 21.9542 36.4934 21.112C22.7354 18.5633 9.75683 28.4292 6.47223 42.4448C7.13252 47.2515 8.79323 51.8664 11.3472 55.9915C13.9011 60.1167 17.2916 63.6606 21.2998 66.3945C25.3079 69.1284 29.8448 70.9917 34.6176 71.864C39.3903 72.7362 44.2929 72.5982 49.009 71.4587Z",
    fill: "url(#paint6_linear_6930_829)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0089 71.4587C32.102 70.7382 21.1832 52.4105 23.6132 35.4343C24.1678 31.5206 26.0521 27.9167 28.9494 25.2278C22.7156 31.0181 21.0133 38.7125 22.2049 46.6281C24.0486 58.9255 35.3514 71.9959 49.0089 71.4595V71.4587Z",
    fill: "url(#paint7_linear_6930_829)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8323 54.7824C18.7975 56.7624 13.8475 55.3391 10.4113 49.9802C12.4703 55.0901 15.7828 59.5992 20.0434 63.0917C24.3039 66.5841 29.3755 68.9475 34.79 69.9639C28.7444 67.1286 24.2304 61.3062 21.8323 54.7824Z",
    fill: "url(#paint8_linear_6930_829)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0027 51.8986L47.528 53.7326C47.3315 53.8783 56.4915 66.3884 56.9988 67.0601C57.5061 67.7318 58.0764 68.1584 58.2728 68.0125L60.7475 66.1785L50.0027 51.8986Z",
    fill: "url(#paint9_linear_6930_829)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M59.1275 65.5083C58.6199 64.8369 49.5156 52.3176 49.7121 52.1719L49.5676 52.2829C49.3712 52.4288 58.4755 64.9476 58.9831 65.6195C59.4907 66.2913 60.0609 66.7176 60.2572 66.5718L60.4015 66.4606C60.2051 66.6065 59.6343 66.1801 59.1275 65.5083Z",
    fill: "url(#paint10_linear_6930_829)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M58.9823 65.6201C58.4747 64.9487 49.3703 52.4295 49.5668 52.2836L49.5526 52.2942C49.3561 52.4399 58.4604 64.9589 58.968 65.6306C59.4756 66.3023 60.0458 66.7288 60.2421 66.5829L60.2562 66.5725C60.0601 66.7182 59.4894 66.2924 58.9823 65.6201Z",
    fill: "url(#paint11_linear_6930_829)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M59.3887 65.3129C58.8811 64.6416 49.7768 52.1223 49.9733 51.9764L49.829 52.0876C49.6325 52.2335 58.7368 64.7522 59.2445 65.4241C59.7521 66.096 60.3221 66.5222 60.5184 66.3765L60.6628 66.2653C60.4658 66.411 59.8953 65.9848 59.3887 65.3129Z",
    fill: "url(#paint12_linear_6930_829)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M59.2428 65.4246C58.7352 64.7532 49.6308 52.234 49.8273 52.0881L49.8133 52.0986C49.6168 52.2445 58.7211 64.7632 59.2287 65.4351C59.7363 66.1069 60.3063 66.5332 60.5027 66.3874L60.5169 66.377C60.3206 66.5229 59.7501 66.096 59.2428 65.4246Z",
    fill: "url(#paint13_linear_6930_829)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M57.6903 66.5856C57.1827 65.9142 48.0784 53.3949 48.2749 53.2492L48.1305 53.3602C47.934 53.5061 57.0383 66.0249 57.5459 66.6968C58.0535 67.3686 58.6235 67.7949 58.82 67.6491L58.9643 67.5379C58.7679 67.6843 58.1975 67.2574 57.6903 66.5856Z",
    fill: "url(#paint14_linear_6930_829)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M57.5451 66.6974C57.0375 66.026 47.9331 53.5068 48.1296 53.361L48.1156 53.3715C47.9191 53.5172 57.0234 66.0362 57.531 66.7079C58.0386 67.3796 58.6086 67.8061 58.805 67.6602L58.8192 67.6497C58.6227 67.7956 58.0522 67.3693 57.5451 66.6974Z",
    fill: "url(#paint15_linear_6930_829)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M57.9508 66.3907C57.4432 65.7193 48.3389 53.2001 48.5354 53.0543L48.3911 53.1653C48.1946 53.3112 57.299 65.83 57.8066 66.5019C58.3142 67.1737 58.8842 67.6 59.0805 67.4542L59.225 67.343C59.0285 67.4878 58.4581 67.0621 57.9508 66.3907Z",
    fill: "url(#paint16_linear_6930_829)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M57.8056 66.5021C57.298 65.8307 48.1936 53.3114 48.3901 53.1655L48.3761 53.176C48.1796 53.3219 57.2839 65.8409 57.7915 66.5125C58.2991 67.1842 58.8691 67.6106 59.0655 67.4649L59.0797 67.4544C58.8834 67.6002 58.3129 67.1738 57.8056 66.5021Z",
    fill: "url(#paint17_linear_6930_829)"
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6073 49.7982C64.6694 56.43 65.604 61.5254 62.781 63.5507C63.8765 62.7647 65.0791 61.9474 66.3136 61.1036C66.6235 60.8919 66.8876 60.6198 67.0904 60.3039C67.2931 59.9879 67.4301 59.6343 67.4935 59.2643C67.5567 58.8942 67.5449 58.5151 67.4586 58.1498C67.3725 57.7845 67.2137 57.4401 66.9916 57.1374L61.6073 49.7982Z",
    fill: "#F1F1F2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6930_829",
    x1: 50.1649,
    y1: 16.523,
    x2: 68.8125,
    y2: 16.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.213,
    stopColor: "#EF4E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631,
    stopColor: "#DF4024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D73926"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6930_829",
    x1: 50.1649,
    y1: 14.7091,
    x2: 65.1806,
    y2: 14.7091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#F9E2BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174,
    stopColor: "#DFB17A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#EDC78E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#EAD4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#E7C18D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713,
    stopColor: "#DFB17A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#F9E2BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#E9B980"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6930_829",
    x1: 31.1365,
    y1: 63.7341,
    x2: 53.4203,
    y2: 56.3404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BD1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#00AFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#1670B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C459B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6930_829",
    x1: 6.45632,
    y1: 34.6373,
    x2: 72.8245,
    y2: -70.9809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.213,
    stopColor: "#EF4E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631,
    stopColor: "#DF4024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D73926"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6930_829",
    x1: 82.8817,
    y1: 3.66384,
    x2: 61.4686,
    y2: 38.9794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF4E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D73926"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6930_829",
    x1: 28.4859,
    y1: 56.2585,
    x2: 49.6851,
    y2: 46.4679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BD1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#00AFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#1670B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C459B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6930_829",
    x1: 38.9703,
    y1: 75.636,
    x2: 0.463222,
    y2: 19.9815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C36BAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#8A3E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C3292"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6930_829",
    x1: 41.2686,
    y1: 67.2207,
    x2: -7.28484,
    y2: 31.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0ACCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#8A3E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C3292"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6930_829",
    x1: 32.6934,
    y1: 78.5568,
    x2: 12.3107,
    y2: 13.6815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCA3C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#8A3E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C3292"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6930_829",
    x1: 64.7557,
    y1: 68.4949,
    x2: 50.2267,
    y2: 48.2143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.065,
    stopColor: "#F3F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37472,
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511852,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#A3A09D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#F7F6F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6930_829",
    x1: -968.103,
    y1: 169.173,
    x2: -968.103,
    y2: 168.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    stopColor: "#E9E7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#ADA69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#B3ADA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#BDB8B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#CCC7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#DEDBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#F5F4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#EEECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#D8D5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#CBC7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#C7C3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#EDE7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#B2AFA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6930_829",
    x1: -968.108,
    y1: 169.186,
    x2: -968.108,
    y2: 168.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    stopColor: "#E9E7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#ADA69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#B3ADA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#BDB8B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#CCC7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#DEDBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#F5F4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#EEECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#D8D5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#CBC7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#C7C3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#EDE7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#B2AFA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6930_829",
    x1: -968.111,
    y1: 168.848,
    x2: -968.111,
    y2: 168.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    stopColor: "#E9E7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#ADA69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#B3ADA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#BDB8B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#CCC7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#DEDBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#F5F4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#EEECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#D8D5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#CBC7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#C7C3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#EDE7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#B2AFA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6930_829",
    x1: -968.105,
    y1: 168.861,
    x2: -968.105,
    y2: 168.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    stopColor: "#E9E7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#ADA69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#B3ADA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#BDB8B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#CCC7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#DEDBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#F5F4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#EEECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#D8D5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#CBC7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#C7C3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#EDE7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#B2AFA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6930_829",
    x1: -968.111,
    y1: 170.971,
    x2: -968.111,
    y2: 170.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    stopColor: "#E9E7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#ADA69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#B3ADA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#BDB8B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#CCC7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#DEDBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#F5F4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#EEECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#D8D5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#CBC7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#C7C3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#EDE7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#B2AFA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6930_829",
    x1: -968.1,
    y1: 170.992,
    x2: -968.1,
    y2: 170.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    stopColor: "#E9E7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#ADA69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#B3ADA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#BDB8B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#CCC7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#DEDBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#F5F4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#EEECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#D8D5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#CBC7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#C7C3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#EDE7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#B2AFA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6930_829",
    x1: -968.108,
    y1: 170.646,
    x2: -968.108,
    y2: 170.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    stopColor: "#E9E7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#ADA69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#B3ADA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#BDB8B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#CCC7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#DEDBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#F5F4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#EEECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#D8D5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#CBC7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#C7C3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#EDE7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#B2AFA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_6930_829",
    x1: -968.109,
    y1: 170.654,
    x2: -968.109,
    y2: 170.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    stopColor: "#E9E7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#ADA69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#B3ADA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#BDB8B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#CCC7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#DEDBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#F5F4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#EEECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#D8D5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#CBC7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#C7C3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#EDE7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#B2AFA8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bfd6aaffc94b4f0c9496acbde6ee3100.svg";
export { ForwardRef as ReactComponent };